<div class="list">
  <div class="actions">
    <!-- <gmt-button [clickAction]="onGenerateFromProject">Vytvořit z projektu</gmt-button> -->
    <a class="button" uiSref="symap.project.vfze.import"><i class="fa fa-plus-square"></i>Import nového VFZE</a>
  </div>

  <h1>Přehled importů</h1>

  <filter [list]="list" (onChanged)="pageableList.onFilterChanged($event)">
    <div class="column-100">
      <input class="fulltext" type="text" placeholder="Fultextové hledání..." [(ngModel)]="list.filter.filters.searchText.values[0].id"/>
    </div>
  </filter>

  <div [loading]="list.loading">
    <div class="table-top-container">
      <div class="invisible cm-select-placeholder"></div>
      <pagescounter *ngIf="list.itemCount && list.list !== null" [list]="list" (callbackRegister)="pageableList.pagescounterCallbackRegister($event)"></pagescounter>
      <div class="page-count-select" *ngIf="list.itemCount && list.list !== null">
        <span>Záznamů na stránce</span>
        <gmt-select required="true" [data]="pageableList.dataPaging" field="itemsPerPage" [optionItems]="pageableList.itemsPerPageItems" (changed)="pageableList.changePageItems()" class="min-width-unset"></gmt-select>
      </div>
    </div>

    <div class="bordered" *ngIf="list.itemCount">
      <div class="table">
        <div class="head-group">
          <div class="row">
            <span class="cell">ID</span>
            <span class="cell">Založeno</span>
            <span class="cell">Jméno souboru</span>
          </div>
        </div>
        <div class="row-group">
          <a class="row" *ngFor="let vfze of list.list" uiSref="symap.project.vfze.detail" [uiParams]="{ id: vfze.id, page: null }">
            <span class="cell">{{ vfze.id }}</span>
            <span class="cell">{{ vfze.createdTimestamp|date : 'medium'  }}</span>
            <span class="cell">{{ vfze.fileName }}</span>
          </a>
        </div>
      </div>
    </div>

    <div class="empty-info bordered pb-20 pt-20 centered-text" *ngIf="!list.itemCount && list.list !== null && !list.loading">
      <span>Nebyla nalezena žádná data.</span>
    </div>
  </div>

  <itemscounter
    *ngIf="list.itemCount && list.list !== null" [list]="list"
    (callbackRegister)="pageableList.itemcounterCallbackRegister($event)"
    style="max-width: 100px;"
  ></itemscounter>

  <pagination
    *ngIf="list.itemCount && list.list !== null"
    [list]="list"
    (callbackRegister)="pageableList.paginationCallbackRegister($event)"
  ></pagination>
</div>

